import React from "react";

function SvgBtnClose(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 27.973 27.973" {...props}>
      <path
        data-name="Path 11442"
        d="M2.41 27.973l11.577-11.577 11.577 11.577 2.41-2.41-11.576-11.577L27.974 2.41 25.564 0 13.987 11.577 2.41.002 0 2.412l11.576 11.576L.002 25.563z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgBtnClose;
